import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { footerClickEvent } from '../../utils/statistics/customEvents';
import ContentoQuery from '../Contento/ContentoQuery';
import ExternalIcon from '../Link/ExternalIcon/ExternalIcon';
import MAIN_GENRES_QUERY from '../PromotionGrid/MainGenres.graphql';
import { ServiceLink, FooterLogo, CogIcon } from './Footer.styles';
import {
    Button,
    Buttons,
    FooterContainer,
    GenreLink,
    Genres,
    GenresList,
    GenresListElement,
    IconContainer,
    Services,
    Service,
} from './Footer.styles.js';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { ButtonLabel } from '../../ui-components/PlayButton/PlayButton.styles';
import PlayText, { TYPES } from '../../ui-components/typography/PlayText/PlayText';
import { regularWhite } from '../../ui-components/design-tokens';
import ExternalTeasers from 'app/components/ExternalTeasers/ExternalTeasers';
import { useRouter } from 'next/router';
import Devices from './components/Devices';

const trackClick = (name) => {
    const event = footerClickEvent(name);
    trackCustomEvent(event);
};

const FooterGenres = () => {
    return (
        <ContentoQuery query={MAIN_GENRES_QUERY}>
            {(data) => {
                const mainGenres = data.genres;

                if (!mainGenres || !mainGenres.length) {
                    return null;
                }

                const lastIndex = mainGenres.length - 1;

                return (
                    <Genres>
                        <nav>
                            <GenresList>
                                {
                                    //remove last genre cause we want to use the "Alla program" link instead
                                    mainGenres.slice(0, -1).map((item, index) => {
                                        return (
                                            <GenresListElement key={`clust-${index}`}>
                                                <PlayText type={TYPES.LARGE} color={regularWhite}>
                                                    <GenreLink
                                                        to={`/genre/${item.id}`}
                                                        onClick={() => {
                                                            trackClick(item.name);
                                                        }}
                                                    >
                                                        <span>{item.name}</span>
                                                    </GenreLink>
                                                </PlayText>
                                            </GenresListElement>
                                        );
                                    })
                                }
                                <GenresListElement key={`clust-${lastIndex}`}>
                                    <PlayText type={TYPES.LARGE} color={regularWhite}>
                                        <GenreLink
                                            className={`lp_pos${lastIndex}`}
                                            to="/program"
                                            onClick={() => {
                                                trackClick('Alla program');
                                            }}
                                        >
                                            <span>Alla program</span>
                                        </GenreLink>
                                    </PlayText>
                                </GenresListElement>
                            </GenresList>
                        </nav>
                    </Genres>
                );
            }}
        </ContentoQuery>
    );
};

const Footer = () => {
    const router = useRouter();
    const isStartpage = router.asPath === '/';

    return (
        <FooterContainer>
            <PlayContainerBase>
                {isStartpage && <ExternalTeasers />}
                <FooterGenres />
                <Devices
                    onDeviceClick={(name) => {
                        trackClick(name);
                    }}
                />
                <IconContainer>
                    <FooterLogo />
                    <PlayText type={TYPES.MINI}>Sveriges Television AB</PlayText>
                </IconContainer>
                <Buttons data-rt="footer-buttons">
                    <Button
                        to="/installningar"
                        onClick={() => {
                            trackClick('Inställningar');
                        }}
                        className="lp_pos1"
                    >
                        <CogIcon aria-hidden="true" />
                        <ButtonLabel>Inställningar</ButtonLabel>
                    </Button>
                    <Button
                        isExternal={true}
                        to="https://kontakt.svt.se"
                        className="lp_pos2"
                        onClick={() => {
                            trackClick('Kontakt');
                        }}
                    >
                        <ExternalIcon isExternal={true}>
                            <ButtonLabel>Kontakt</ButtonLabel>
                        </ExternalIcon>
                    </Button>
                </Buttons>
                <Services>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://www.svt.se"
                            text="svt.se"
                            onClick={() => {
                                trackClick('svt.se');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://nyhetsbrev.svtplay.se/prenumerera/?utm_source=svtplay&utm_medium=footer-cta"
                            text="Nyhetsbrev"
                            onClick={() => {
                                trackClick('Nyhetsbrev');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://www.oppetarkiv.se"
                            text="oppetarkiv.se"
                            onClick={() => {
                                trackClick('oppetarkiv.se');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://kontakt.svt.se/guide/cookies-och-personuppgifter"
                            text="Om cookies"
                            onClick={() => {
                                trackClick('Om cookies');
                            }}
                        />
                    </Service>
                </Services>
            </PlayContainerBase>
        </FooterContainer>
    );
};

Footer.propTypes = {
    content: PropTypes.object,
};

export default Footer;
